import { useEffect } from 'react';
import { useBlocker, useLocation } from 'react-router-dom';
import PATH from '../routes/path';
import useBlockDialogStore from '../store/useBlockDialogStore';

export const usePrompt = (when: boolean) => {
  const { setOpen, setType, setOnOk } = useBlockDialogStore();

  const blocker = useBlocker(when);
  const location = useLocation();

  useEffect(() => {
    if (when)
      window.onbeforeunload = e => {
        e.preventDefault();
        e.returnValue = '';

        return null;
      };
    else window.onbeforeunload = null;
    return () => {
      window.onbeforeunload = null;
    };
  }, [when, blocker]);

  useEffect(() => {
    if (blocker?.state === 'blocked') {
      if (!Object.values(PATH).includes(location.pathname.slice(1))) {
        setType('push');
        setOnOk(() => {
          setTimeout(() => {
            blocker.proceed();
          }, 0);
        });

        setOpen();
      } else {
        setTimeout(() => {
          blocker.proceed();
        }, 0);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [blocker]);
};
